const isAdmin = profile => {
  return profile?.type === 'A'
}

export default isAdmin
